<!-- <script src="//cdnjs.cloudflare.com/ajax/libs/blueimp-md5/2.10.0/js/md5.min.js"></script> -->
<template>
  <v-container class="white-wrapper" fluid>
    <!-- <phone-overlay :show="!auth_sms" :back="true"></phone-overlay> -->
    <div
      style="max-width:25rem;margin:0 auto;height:100%;display:flex;flex-direction:column;justify-content:space-between;padding: 0 1rem;"
    >
    
     <v-card>           
          <v-tabs
            v-model="tab1"
            color="deep-purple-accent-4"
            align-tabs="center"
          > 
            <v-tab v-on:click.self.prevent  @click="tab1Act(0)" style="width:33%;">KYC</v-tab>
            <v-tab :disabled="(this.vinfo.KYC==4)?false:true" @click="tab1Act(1)" style="width:33%;">Card</v-tab>
            <v-tab  style="width:33%;">Recommend</v-tab> <!--  @click="tab1Act(2)" -->

          </v-tabs>          
      </v-card>
      <!-- border:1px solid red -->
      <div v-show="tab1===0" style="height: 90%;">         
        <!-- {{ cardHolderId }} -->
        <div class="d-flex select-item justify-space-between px-4 mb-5">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center" style="font-size: 20px;">                
                {{$t('cards.OwnerInformation')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">                          
            </v-row>
          </div>



          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">
                - {{$t('cards.LastName')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.lastName }}
            </v-row>
          </div>


          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">
                -  {{$t('cards.FirstName')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.firstName }}
            </v-row>
          </div>

          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">                
                -  {{$t('cards.eMail')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.email }}
            </v-row>
          </div>
  
          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">
                - {{$t('cards.Mobile')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.mobile }}
            </v-row>
          </div>

          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">
                - {{$t('cards.BirthDay')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.birthday }}
            </v-row>
          </div>

          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">
                - {{$t('cards.Gender')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ ( this.vinfo.sex == 'm' )?'Male':'Female' }}
            </v-row>
          </div>


          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">                
                - {{$t('cards.NationalityCode')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.nationality }}
            </v-row>
          </div>

          <div class="d-flex select-item justify-space-between px-4 mb-10">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">                
                - {{$t('cards.IDNumber')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ this.vinfo.idNumber }}
            </v-row>
          </div>
          <!-- KYC 인증  -->  
          <!-- 
              0: 미신청
              1: 소유자 정보 등록 user->kyc_info 리턴객체 확인 
              2: 카드 등록  user->card_info 리턴객체 확인 
              3: 승인 완료
          -->
         <div v-show="this.CARD&& this.CARD.cardNo"  >  
            <div class="d-flex select-item justify-space-between px-4 mb-5">            
              <div class="d-flex align-center justify-center"> 
                <div class="font-weight-black d-flex align-center" style="font-size: 20px;">                  
                  {{$t('cards.CardInformation')}}
                </div>
              </div> 
              <v-row class="font-weight-medium d-flex align-center justify-end">                          
              </v-row>
            </div>

            <div  class="d-flex select-item justify-space-between px-4 mb-10">            
              <div class="d-flex align-center justify-center"> 
                <div class="font-weight-black d-flex align-center">
                  - {{$t('cards.CardNumber')}}
                </div>
              </div> 
              <v-row class="font-weight-medium d-flex align-center justify-end">              
                {{ vwCardNo(this.CARD.cardNo)  }}
              </v-row>
            </div>

         </div>



          <div   class="d-flex select-item justify-space-between px-4" style="margin-bottom: 20px;;" >                      
            
            <div v-show="this.vinfo.KYC==1" style="color:red;text-align: center;  margin: 0 auto;font-weight: 900;  border-radius: 25px;
              border: 2px solid hwb(249 0% 67%);padding: 20px;"> 
              Please register your card information
            </div>             

            <div v-show="this.vinfo.KYC==2||this.vinfo.KYC==3" style="color:red;text-align: center;  margin: 0 auto;font-weight: 900;  border-radius: 25px;
              border: 2px solid hwb(249 0% 67%);padding: 20px;"> 
              
              <p v-if="this.activa==null">
                Please allow 1-3 days for verification. </br>              
                The rest of the features will be open after approval.
              </p>
              <p v-else-if="this.activa.auditRemark!=''">
                {{ this.activa.auditRemark }}
                {{ this.activa.created_at }}
              </p>
              <p v-else >
                approval process has started. </br>
                {{ this.activa.created_at }}
              </p>
            </div>             
          </div>

          <v-btn
            v-show="this.vinfo.KYC!=4  && (this.vinfo.KYC==0 || (this.activa && this.activa.auditStatus!='')) "
            class="font-weight-bold mb-4"
            color="primary"
            @click="fn_chechKyc()"
            x-large
            block          
          >
            Modify infomation
          </v-btn>

          <v-btn
            v-show="this.vinfo.KYC==1"
            class="font-weight-bold mb-4"
            color="primary"
            @click="fn_registerCard()"
            x-large
            block          
          >
            Register CARD
          </v-btn>


         

          <!-- 
            <v-btn
              v-show="this.vinfo.KYC==2"
              class="font-weight-bold mb-4"
              color="primary"
              @click="fn_chechKyc()"
              x-large
              block          
            >
              Check KYC
            </v-btn> 
          -->
          
      </div>      

      <div v-show="tab1==1" style="height: 90%;"> 
        <!-- 카드정보  -->             

          <div class="d-flex select-item justify-space-between px-4 mb-5">            
              <div class="d-flex align-center justify-center"> 
                <div class="font-weight-black d-flex align-center" style="font-size: 20px;">                  
                  - {{$t('cards.Balance')}}
                </div>
              </div> 
              <v-row class="font-weight-medium d-flex align-center justify-end">                          
              </v-row>
          </div> 
 
          <div class="d-flex select-item justify-space-between px-4 mb-1">            
 
                <div class="d-flex align-center justify-center"> 
                  <div class="font-weight-black d-flex align-center">
                    - {{$t('cards.CardNumber')}}
                  </div>
                </div> 
                <v-row class="font-weight-medium d-flex align-center justify-end">              
                  {{ vwCardNo(this.CARD.cardNo)  }}
                </v-row>
          </div>              
            
          <div class="d-flex select-item justify-space-between px-4 mb-10">            
              <div class="d-flex align-center justify-center"> 
                <div class="font-weight-black d-flex align-center">
                  - {{$t('cards.Amount')}}
                </div>
              </div> 
              <v-row class="font-weight-medium d-flex align-center justify-end">              
                {{ amount }} EUR
              </v-row>
          </div>      
          
          <!-- 충전목록 -->
          <div class="d-flex select-item justify-space-between px-4 mb-1">            
              <div class="d-flex align-center justify-center"> 
                <div class="font-weight-black d-flex align-center" style="font-size: 20px;">
                  {{$t('cards.Charged')}}
                  <v-btn
                      icon                                             
                      title="trade History"
                      @click="goHistory()" 
                    >
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                  
                </div>
              </div> 
              <v-row class="font-weight-medium d-flex align-center justify-end">                          
              </v-row>
          </div> 

          <div  v-if="!charged[0]"  class="d-flex select-item justify-space-between px-4 mb-10">            
            - No charge history.
          </div>
          <div  v-for="(item) in charged" :key="item.id" class="d-flex select-item justify-space-between px-4 mb-10">            
              <div class="d-flex align-center justify-center"> 
                <div class="font-weight-black d-flex align-center">
                  
                  <label>
                    
                    <v-icon v-show="item.confirmed_at!=null" color="primary" small> mdi-check-circle-outline </v-icon>                                    
                    <v-icon v-show="item.confirmed_at==null" color="orange" small> mdi-swap-horizontal-circle-outline </v-icon> 

                    {{ dateFormatt(item.created_at) }}

                    <!-- <v-icon color="error" small> mdi-alert-circle-outline </v-icon> -->
                    
                    
                  </label>                   
                </div>
              </div> 
              <v-row class="font-weight-medium d-flex align-center justify-end">              
                <label> {{ item.vAmount_to }} EUR </label>
                 
              </v-row>
          </div> 

          <!-- 충전목록 -->
 

            <v-btn
              
              class="font-weight-bold mb-4"
              color="primary"
              @click="goSwap()"
              x-large
              block          
            >
              Charge Card
            </v-btn>   
        <!-- 카드정보  -->             
      </div>      
      <div v-show="tab1==2" style="height: 90%;"> 
        <!-- 추천인 링크&QR 정보 -->      

          <div class="d-flex select-item justify-space-between px-4 mb-5">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center" style="font-size: 20px;">
                {{$t('cards.RecommendInformation')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">                          
            </v-row>
          </div>



          <div class="d-flex select-item justify-space-between px-4 mb-1">            
            <div class="d-flex align-center justify-center"> 
              <div class="font-weight-black d-flex align-center">
                - {{$t('cards.ReferCode')}}
              </div>
            </div> 
            <v-row class="font-weight-medium d-flex align-center justify-end">              
              {{ referCode }}
            </v-row>
               
          </div>            

          <div class="d-flex select-item justify-space-between px-4 mb-1">            
         
            <div class="d-flex align-center justify-center" style="margin: 0 auto;padding: 30px; " > 
              <!-- QR생성 -->
              <v-fade-transition leave-absolute >
                <vue-q-r-code-component                                                                 
                        :size="200"
                        :text="this.jsonDataTxt"
                        class="qr-code"
                      />
              </v-fade-transition>
     
              <!-- :value="this.referUrl"  -->
            </div>
            
          </div>

          <div  v-show="true">              
              <input type="hidden" id="referUrl" v-model="referUrl" /> 
          </div>
 

          <v-btn
            
            class="font-weight-bold mb-4"
            color="primary"
            @click="copyCode()"
            x-large
            block          
          >
            COPY TO CLIPBOARD
          </v-btn>  
      </div>    
    </div> 

 
 
    <v-bottom-sheet v-model="cardDialog" scrollable>
      <v-card class="rounded-lg" style="min-height: 50vh;">
        <!-- kyc  -->
        <v-card-title> Card Information </v-card-title>
        <v-card-text class="type-wrapper" >
           
          
          <div class="sheet-row">
            <v-text-field
              type="number"
              class="swap-input-wrapper"
              label="Card Number"
              placeholder="CARD - 12 digit number"
              v-model="CARD.cardNo"               
            >
            </v-text-field>            
          </div>

          <div class="sheet-row">
            <v-text-field
              type="number"
              class="swap-input-wrapper"
              label="CVV"
              placeholder="CVV - 3 digit number"
              v-model="CARD.cvv" 
            >
            </v-text-field>            
          </div>

           
 
          <v-divider class="my-5"></v-divider>

        </v-card-text>

        <!-- kyc  --> 

        <v-btn
          color="primary"
          fixed
          style="bottom:0;"
          tile
          block
          large
          height="56px"
          @click="submitCard" 
        >
          <!-- 신청하기 -->
          Register
        </v-btn>
      </v-card>

    </v-bottom-sheet>


    <v-bottom-sheet v-model="confirmDialog" scrollable>
      <v-card class="rounded-lg" style="min-height: 50vh;">
        <!-- kyc  -->
        <v-card-title> KYC User Information </v-card-title>
        <v-card-text class="type-wrapper" >
          <div class="sheet-title1">* Infomation</div>          
          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="Last name"
              placeholder="last name"
              v-model="KYC.info.last_name" 
            >
            </v-text-field>            
          </div>

          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="First name"
              placeholder="first name"
              v-model="KYC.info.first_name" 
            >
            </v-text-field>            
          </div>

          <div class="sheet-row">
            <v-autocomplete
              label="Gender"
              v-model="KYC.info.gender"
              :items ="this.vwObj.gender"              
            ></v-autocomplete>
          </div>

          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="E-Mail"
              placeholder="E-Mail"
              v-model="KYC.info.email" 
              @change="methodKYC()"
            >
            </v-text-field>            
          </div>


          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="Mobile"
              placeholder="Mobile"
              v-model="KYC.info.mobile" 
            >
            </v-text-field>            
          </div>
 

          <div class="sheet-row">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                >

                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date"
                            label="Date of birthday"                        
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          ref="picker"
                          v-model="date"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save"
                        ></v-date-picker> 
                        
                </v-menu> 
          </div>

          <div class="sheet-row">            
            <v-autocomplete
              label="Nationality"
              v-model="KYC.info.nationality"
              :items ="this.vwObj.nationality"              
            ></v-autocomplete>
          </div>

          <!-- <div class="sheet-row">
            
            <template>
              <v-file-input
                label="proofResidence-거주지증명"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"
                v-model="KYC.info.proofResidence" 
              ></v-file-input>
            </template>

          </div> -->
          <!-- Infomation End  -->

          <div class="sheet-title1">* Passport</div>          

          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="Passport Number"
              placeholder="Passport Number"
              v-model="KYC.info.idNumber" 
            >
            </v-text-field>            
          </div>
       
          <div class="sheet-row">            
            <!-- 
              accept="image/jpg, image/jpeg, application/pdf" 
              :rules="rules" 
           -->
            <template>              
              <v-file-input                                
                label="Holing passport Photo"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"                
                type="file"
                ref="facePhoto"
                v-model="facePhoto" 
                @change="previewFile('facePhoto')"
                                
              ></v-file-input>
            </template>
          </div>

          <div class="sheet-row">            
            <template>
              <v-file-input
                label="Passport Front Photo"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"
                ref="idFrontPhoto"
                v-model="idFrontPhoto" 
                @change="previewFile('idFrontPhoto')"
              ></v-file-input> 
            </template>
          </div>
          
          <!-- 
            <div class="sheet-row">            
              <template>
                <v-file-input
                  label="Passport Back Photo"
                  variant="filled"
                  show-size 
                  prepend-icon="mdi-camera"
                  v-model="KYC.info.idBackPhoto" 
                ></v-file-input>
              </template>
            </div> 
          -->


          <!--  
            "facePhoto": "string", - (얼굴인식 사진 - base64인코딩, 사진은 1M미만, 필수) 
            "idBackPhoto": "string", - (여권뒷면 사진 - base64인코딩, 사진은 1M미만, 필수)
            "idFrontPhoto": "string", - (여권앞면 사진 - base64인코딩, 사진은 1M미만, 필수)            
            "idNumber": "string", - (여권번호, 필수)            
          -->
 
          <v-divider class="my-5"></v-divider>

        </v-card-text>

        <!-- kyc  --> 

        <v-btn
          color="primary"
          fixed
          style="bottom:0;"
          tile
          block
          large
          height="56px"
          @click="submitKYC" 
        >
          <!-- 신청하기 -->
          Request KYC
        </v-btn>
      </v-card>

    </v-bottom-sheet>
    

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="message"> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="messageModal = false">
            {{ $t('swap.messageModal.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>

import PhoneOverlay from '../../components/PhoneOverlay.vue'

import VueQRCodeComponent from 'vue-qrcode-component' ;
import VueBarcode from 'vue-barcode' ; 
import $ from 'jquery' ; 
import { QrcodeStream } from 'vue-qrcode-reader' ;  // , QrcodeDropZone, QrcodeCapture 

export default {
  components: { PhoneOverlay,VueQRCodeComponent, VueBarcode , QrcodeStream  },
  mounted(){
 
    const md5_Script = document.createElement("script");
    md5_Script.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/blueimp-md5/2.10.0/js/md5.min.js"
    );
    document.head.appendChild(md5_Script);

    const axios_Script = document.createElement("script");
    axios_Script.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/axios/dist/axios.min.js"
    );
    document.head.appendChild(axios_Script);


  } ,
 

  data: () => ({
    referUrl : null,
    referCode : null , 
    jsonDataTxt :null ,
    qrCodeData: '' , 
    charged : {} ,
    activa : {} , 
    vinfo:{} , 
    cinfo:{} , 
    cardHolderId: null , 
    tab1: 0,
    CARD : {} , 
    KYC:{info:{}}  ,
    kyc_proc: 0 , 
    amount : 0 , 
    idFrontPhoto:null , 
    facePhoto : null , 
    previewImgUrl: null, // 미리보기 이미지 URL
        isUploading: false, // 파일 업로드 체크
        response: null, // 파일 업로드후 응답값
        
    date: null,
    menu: false ,     
    activePicker: null, 
    fee: null,
    valid: true,
    fromType: null,
    toAddress: '',
    configId: null,
    toType: null,
    fromAmount: null,
    toAmount: 0,
    amountRules: [(v) => !!v || '', (v) => v > 0 || ''],
    coinRules: [(v) => !!v || ''],
    messageModal: false,
    message: null,
    confirmDialog: false ,
    cardDialog :false ,
    fee: null,
    noConfig: false,
    hash: null , 

    selectAry:['Afghanistan','Canada','Zimbabwe'] , 
    vwObj :  {
      // nationality : ['Afghanistan','Canada','Zimbabwe','Zambia','Yugoslavia','Yemen','Yemen','Wallis and fortuna','Vietnam','Venezuela','Vatican City','Vanuatu','Uzbekistan','Uruguay','United States Virgin Islands','United States','United Kingdom','United Arab Emirates','Ukraine','Uganda','Tuvalu','Turks and caicos islands','Turkmenistan','Turkey','Tunisia','Trinidad and Tobago','Tonga','Tokelau islands','Togo','The Republic of Congo','the Falkland Islands','The east German','The Dominican Republic','Thailand','Tanzania','Tajikistan','Taiwan','Syria','Switzerland','Sweden','Swaziland','Suriname','Sudan','Sri Lanka','Spain','South Sudan','South Africa','Somalia','Solomon Islands','Slovenia','Slovakia','Sint Maarten','Singapore','Sierra Leone','Seychelles','Serbia','Senegal','Saudi Arabia','Sao Tome and Principe','San Marino','Samoa','Saint Vincent and the Grenadines','Saint Pierre and Miquelon','Saint Lucia','Saint Kitts-Nevis','Saint Helena','Rwanda','Russia','Romania','Reunion','Qatar','Puerto Rico','Portugal','Poland','Philippines','Peru','Paraguay','Papua New Guinea','Panama','Palestine','Palau','Pakistan','Oman','Norway','Northern Mariana Islands','Niue','Niger','Nicaragua','New Zealand','New Caledonia','Netherlands','Nepal','Nauru','Namibia','Myanmar','Mozambique','Morocco','Montserrat','Montenegro','Mongolia','Monaco','Moldova','Micronesia','Mexico','Mauritius','Mauritania','Martinique','Marshall Islands','Malta','Mali','Maldives','Malaysia','Malawi','Madagascar','Macedonia','Macao','Luxembourg','Lithuania','Liechtenstein','Libya','Liberia','Lesotho','Lebanon','Latvia','Laos','Kyrgyzstan','Kuwait','Korea','Kiribati','Kazakhstan','Jordan','Japan','Jamaica','Italy','Israel','Ireland','Iraq','Iran','Indonesia','India','Iceland','Hungary','Hong kong','Honduras','Haiti','Guyana','Guinea-Bissau','Guinea','Guatemala','Guam','Guadeloupe','Grenada','Greenland','Greece','Gilbert islands','Gibraltar','Ghana','Germany','Georgia','Gambia','Gabon','French Polynesia','French Guiana','France','Finland','Fiji','Faroe Islands','Ethiopia','Estonia','Eritrea','Equatorial Guinea','Ellis islands','El Salvador','Egypt','Ecuador','East Timor','Dominica','Djibouti','Diego Garcia','Denmark','Democratic Republic of the Congo','slovakia','Czecho','Cyprus','Curacao','Cuba','Croatia','Cote D`Ivoire','Costa Rica','Cook Islands','Mayotte ','Comoros ','Colombia','China','Chile','Chad','Central African Republic','Cayman Islands','Caribbean Netherlands','Cape Verde','Cameroon','Cambodia','Burundi','Burkina Faso','Bulgaria','Brunei','British Virgin Islands','Brazil','Botswana','Bosnia and Herzegovina','Bolivia','Bhutan','Bermuda','Benin','Belize','Belgium','Belarus','Barbados','Bangladesh','Bahrain','Bahamas','Azerbaijan','Austria','Australia','Ascension Island','Aruba','Armenia','Argentina','Antigua and Barbuda','Anguilla','Angola','Andorra','American Samoa','Algeria','Albania']
      nationality : ['Korea','USA','Japan' , 'China','Singapore' ,'Philippines','Vietnam','Thailand','Malaysia','Indonesia'] , 
      nationality_number : ['82','1','81' , '86','65','63','84','66','60','62'] ,
      gender :   ['Male'  , "Female" ]  , 
      na_long : {
                    "Korea" : ["+82" , "KR"] , 
                    "USA" : ["+1" , "US"] , 
                    "Japan" : ["+81" , "JP"] , 
                    "China" : ["+86" , "CN"] , 
                    "Singapore" : ["+65" , "SG"] , 
                    "Philippines" : ["+63" , "PH"] , 
                    "Vietnam" : ["+84" , "VN"] , 
                    "Thailand" : ["+66" , "TH"] , 
                    "Malaysia" : ["+60" , "MY"] , 
                    "Indonesia" : ["+62" , "ID"] ,                     
                }  ,
      na_short : {
          "KR" : ["+82" , "Korea"] , 
          "US" : ["+1" , "USA"] , 
          "JP" : ["+81" , "Japan"] , 
          "CN" : ["+86" , "China"] , 
          "SG" : ["+65" , "Singapore"] , 
          "PH" : ["+63" , "Philippines"] , 
          "VN" : ["+84" , "Vietnam"] , 
          "TH" : ["+66" , "Thailand"] , 
          "MY" : ["+60" , "Malaysia"] , 
          "ID" : ["+62" , "Indonesia"] , 
      }   
 

    } , 
    rules: [
      files => !files || !files.some(file => file.size > 1_097_152) || 'Avatar size should be less than 1MB!'
    ],

  }),
  computed: {    
    loading() {
      return this.$store.getters.loading
    },    
    myWalletAdress() {
      console.log( 'myWalletAdress' )
      return this.$store.getters.user.wallet_address
    },
    wallet() {
      
      // let _temp = this.$store.getters.wallet.filter(
      //   (i) => i.name == 'EUR' 
      // )
      // let _tempAry = [] ; 
      // let _sort = ["ETH","USDT","EUR","TRX","HLM","MATIC","CCS","CCC","LSS","PCC","PGP"] ; 

      // _temp.map((item , i) => {        
      //   _tempAry[_sort.indexOf(item.name) ] = item ; 
      // }) ; 
      // return _tempAry //Ary
      
      
    },
  },
  created() {
    
     this.$store.commit('loading', true)     

     this.setReferInfo();
   

     this.$store
              .dispatch('kyc_chk', {'act' : 'load'})
              .then((res) => { 
                
                this.confirmDialog = !res.data.result  ; 
                
                if( res.data.result ) {
                   

                  this.vinfo = (res.data._data) ? res.data._data : null   ;
                  this.CARD =  (res.data._card) ? res.data._card : {cardNo:'' , cvv :''}    ;
                  this.activa =   (res.data._activa) ? {...res.data._activa} : null   ;
                  this.charged =   (res.data._charged) ? {...res.data._charged} : null   ; 
 
                  
                  // this.vinfo =(res.data._card) ? res.data._data : null   ;
                  // this.CARD = (res.data._card) ? res.data._card : null    ;


                  this.KYC.info = this.vinfo  ;
                  this.KYC.info.mobile  = this.vinfo.mobile.replace( this.vwObj.na_short[this.vinfo.nationality][0]+"-" , '' ) 
                  // //console.log( this.vinfo.mobile , this.vwObj.na_short[this.vinfo.nationality] ) ;
                     
                  this.KYC.info.nationality = this.vwObj.na_short[this.vinfo.nationality][1]    ;

                  this.date = this.vinfo.birthday ; 
                  this.KYC.info.gender = (this.vinfo.sex== 'm') ? 'Male' : 'Female' ; 
                  
                  this.KYC.info.first_name  = this.vinfo.firstName ; 
                  this.KYC.info.last_name = this.vinfo.lastName ;                   
                  
                   
                } ;
                
           

                this.cardHolderId = (res.data.kyc_id && res.data.kyc_id > 0 )? res.data.kyc_id :null  ; 
                this.vinfo.KYC = res.data.kyc || 0 ;   
                this.kyc_proc= res.data.kyc || 0 ;  
                
                if( this.activa ) {
                    // console.log("activa :: " , this.activa  , this.dateFormatt(  this.activa.created_at )) ;
                  
                  this.activa.created_at =  this.dateFormatt(  this.activa.created_at )  ; 
                  if(this.activa.auditStatus=="success") {

                    this.$store.dispatch('FETCH_WALLET') ; 
                    let items = this.$store.getters.wallet.filter(function(item){
                         if(item.name == 'EUR') return item ; 
                      }) ; 
                      // console.log("balance :: " , items[0].balance , items.balance  ) ; 
                    this.amount = items[0].balance; 

                  }else{
                    // activa.created_at
                    // this.vinfo.KYC=1
                  }
                } ;

                
                 //console.log(  "kyc_proc:: " , this.kyc_proc , this.vinfo.KYC , this.vinfo  )
 

                this.$store.commit('loading', false) ;                 

              })
              .catch((err) => {
                this.$store.commit('loading', false)
                console.error("err::" , err )
                // this.$store.dispatch('toast', {
                //     toast: true,
                //     toast_msg: this.$t('errorServer'),
                //     timeout: 3000
                //   }) ;   
              }) ; 
  },
  watch: {
    menu (val) {
       // val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))       
       val && setTimeout(() => (this.activePicker = this.picker || 'DATE'))
    } ,      
    checkKYC(){
      //console.log("watch->checkKYC()")  ; 
      return true ;  
    } , 

  },
  methods: { 
    goHistory(){
      this.$router.push({path:'/config/cards'}) 
    } , 
    goSwap(){
      this.$router.push({ path: '/config/swap' })
    } ,
    dateFormatt(source, delimiter = '-') {
     
     source = new Date( source ) ; 

     function leftPad(value){
        if (value >= 10) {
          return value;
        } ;  
        return `0${value}`;
      } 

      const year = source.getFullYear();
      const month = leftPad(source.getMonth() + 1);
      const day   = leftPad(source.getDate());
      const hour  = leftPad(source.getHours());
      const min   = leftPad(source.getMinutes());
      const sec   = leftPad(source.getSeconds()); 
      const _times = [hour , min , sec ].join(':') ; 
      const _date  = [year, month, day ].join(delimiter); 
      return  [_date , _times] .join( ' ' )
    } , 

    setReferInfo () { 
      // window.location.protocol + '//' + window.location.hostname 
      // ex) http://172.30.1.39:8080/#/refer/qwe21eqw

      // console.log( window.location.protocol + '//' + window.location.hostname    ) ;
      // console.log( this.$store.getters.user.refer ) ;
      if( this.$store.getters.user.refer ) {
        // let _referUrl =  window.location.protocol + '//' + window.location.hostname +"/#/refer/"+this.$store.getters.user.refer;  
        let _referUrl =   window.location.origin +"/#/refer/"+this.$store.getters.user.refer;          

        this.referUrl = _referUrl ; 
        this.jsonDataTxt= _referUrl ;
        this.referCode = this.$store.getters.user.refer ;  
      } ; 

    }, 
    vwCardNo(str){
      // 4자리 하이픈(-)
      if(str) {
        return str.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})$/, `$1-$2-$3-$4`);
      } else{
        return  str ; 
      }
      
    },
    copyCode() {
      let codeToCopy = document.querySelector('#referUrl')
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
 

      try {
        var successful = document.execCommand('copy')

        if (successful) {
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: 'referral link has been copied.',
            timeout: 2000
          })
        } else throw new Error('fail')

        this.dialog = false
      } catch (err) {
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: 'Copying referral link failed.',
          timeout: 2000
        })
      }

      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    submitCard(){
        
       // console.log( "CARD :: " , this.CARD.cardNo , this.CARD.cvv  )  ; 
       console.error( this.CARD.cardHolderId ) ;
 
       this.$store.commit('loading', true ) ;  
       this.$store
                  .dispatch('card_activa',  this.CARD )
                  .then((res) => {
                    this.$store.commit('loading', false) ; 
                    
                    alert(res.data.rData.msg) ; 
                    if( res.data.result == true)  {
                      location.reload(); 
                    } ; 
                  })
                  .catch((err) => {
                    this.$store.commit('loading', false)
                    console.error("err::" , err )
                    // this.$store.dispatch('toast', {
                    //     toast: true,
                    //     toast_msg: this.$t('errorServer'),
                    //     timeout: 3000
                    //   }) ;   
                  }) ;  

    } ,  
    fn_registerCard(){ 
      this.cardDialog = true ;
    } , 
    fn_chechKyc(){ 

      if( this.vinfo.KYC > 0 ){
        if( this.activa && this.activa.auditStatus!='')  {
          this.confirmDialog = true ; 
        }else{
          this.$store.dispatch('toast', {
                toast: true,
                toast_msg:  'Pending approval.',
                timeout: 2000
              }) ;   
        } ; 
      }else{
        this.confirmDialog = true ; 
      } 

    } , 
    tab1Act( num ){
      
      // this.vinfo
      //console.log(this.kyc_proc)
      //console.log(this.vinfo , this.vinfo.KYC )
      
        if( this.vinfo.KYC!=2   ) {
          if( this.vinfo.KYC == 0 ) {
            this.confirmDialog = true ;
            this.tab1 = 0   ; 

          }else if(this.vinfo.KYC ==1){            
             this.tab1 = 1   ; 
             this.$store.dispatch('toast', {
                toast: true,
                toast_msg:  'Pending approval.',
                timeout: 2000
              }) ;   
              this.tab1 = 0   ; 
          }

        }else{
          this.tab1 = num  ; 
        } ; 
    },
   async previewFile(t) {
    
        // t === idFrontPhoto or facePhoto
        let  fileObj  = null 
        let _fileObj  = null 
            _fileObj  =  ( t == 'facePhoto' )  ? this.facePhoto : this.idFrontPhoto  ;

            // //console.log( "fileObj:: " , _fileObj.size ,  this.facePhoto   , this.$refs.facePhoto    )

        // 선택된 파일이 있는가?
        if (0 < _fileObj.size ) {   
          
          // 마지막 . 위치를 찾고 + 1 하여 확장자 명을 가져온다.
          let fileExt = _fileObj.name.substring(
            _fileObj.name.lastIndexOf(".") + 1
          ) 

          // 소문자로 변환
          fileExt = fileExt.toLowerCase() ; 
          //console.log(fileExt) ; 

          // 이미지 확장자 체크, 1메가 바이트 이하 인지 체크
          if (
            ["jpeg", "png", "gif", "jpg","bmp"].includes(fileExt) &&
            _fileObj.size <= 1048576
          ) { 
                    // // FileReader 를 활용하여 파일을 읽는다
                    // var reader = new FileReader()
                    // reader.onload = e => {
                    //   // base64
                    //   this.previewImgUrl = e.target.result
                    // }
                    // reader.readAsDataURL(this.idFrontPhoto) 

                    // 파일 업로드 ! 

                // L.Cash info
                const _API = "https://open.l.cash" ; 
                const _APP_KEY = "MK3721498"; 
                const _APP_SECRET= "mc6ju3cyid73zqrc756fkiknx";  
                
                // const _TS = Math.floor(new Date().getTime() / 1000);
                const _TS = Date.now() ; 

                const _sign = "APPKEY="+_APP_KEY+"&TS="+_TS+"&APPSECRET="+_APP_SECRET ; 
                const _SIGN = md5( _sign )  ;

                // //console.log(_TS , _sign ,  _SIGN )
                
                this.$store.commit('loading', true) ; 
                const form = new FormData(); 
                    
                    form.append("appKey", _APP_KEY );                    
                    form.append("file", _fileObj  )

                    form.append("sign", _SIGN );
                    form.append("ts", _TS ); 

                  let rData =  await axios.post('https://open.l.cash/common/file/upload' , form, {
                      headers: {                       
                          // 'Content-Type' :'application/json' , 
                          "Content-Type": "multipart/form-data",
                          'Accept-Language' : 'en-US'
                      },
                    })
                    .then(response => {
                      this.$store.commit('loading', false ) ;                     
                        if( t == 'facePhoto' )  {
                          this.facePhoto.uploadKey = response.data.data; 
                        }else {
                          this.idFrontPhoto.uploadKey = response.data.data; 
                        } ; 
                    } )
                    .catch(error => {
                        this.$store.commit('loading', false ) ; 
                        if ( t == 'facePhoto' ) {
                          this.facePhoto = null
                        }else{
                          this.idFrontPhoto = null
                        }
                        this.previewImgUrl = null                    
                    } )

                    

          } else if ( _fileObj.size <= 1048576) {
            // alert("파일을 용량은 최대 1M 입니다. 다시 선택해 주세요.") ; 
            alert("The file size cannot exceed 1MB.") ; 
            // 이미지외 파일            
            if ( t == 'facePhoto' ) {
              this.facePhoto = null
            }else{
              this.idFrontPhoto = null
            }
            this.previewImgUrl = null

          } else {

            alert("Please select the file again.")
            if ( t == 'facePhoto' ) {
              this.facePhoto = null
            }else{
              this.idFrontPhoto = null
            }
            this.previewImgUrl = null

          }
        } else {
          
          // 파일을 선택하지 않았을때
            if ( t == 'facePhoto' ) {
              this.facePhoto = null
            }else{
              this.idFrontPhoto = null
            }

            this.previewImgUrl = null
        }

       //  //console.log( 'fileObj ')
    },
    methodKYC(){
      //console.log(this.value) ; 
    } , 
    objCheck( ob ){
      return (ob && ob != '' && ob != null ) ? true : false ; 
    } , 
    save (date) {
      this.$refs.menu.save(date)
    } , 
    imgSrc(item) {
      console.error( item ) ; 
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },  
    onChangeFrom() {
      //console.log(" onChangeFrom  event ") 
    },
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()

      let regx = /^\d*[.]\d{8}$/
      if (this.fromType === 'usdt') regx = /^\d*[.]\d{6}$/
      if (this.fromType === 'pli' || this.fromType === 'plp')
        regx = /^\d*[.]\d{2}$/
      const _value = e.target.value

      if (regx.test(_value)) e.preventDefault()
    }, 
    onClickMax() {
   
    },
 
    submitKYC(){
    
    this.$store.commit('loading', true ) ; 

    if( !this.facePhoto || !this.facePhoto.uploadKey  ){
      alert('Please select a file [Holing passport Photo].') ; 
      this.$store.commit('loading', false  ) ; 
      return  ;
    }

    if( !this.idFrontPhoto || !this.idFrontPhoto.uploadKey  ){      
      alert('Please select a file [passport Photo].') ; 
      this.$store.commit('loading', false  ) ; 
      return  ;
    }

    if( 
 
      this.objCheck( this.KYC.info.email ) &&       
      this.objCheck( this.KYC.info.first_name ) && 
      this.objCheck( this.KYC.info.gender ) &&             
      this.objCheck( this.KYC.info.idNumber ) && 
      this.objCheck( this.KYC.info.last_name ) && 
      this.objCheck( this.KYC.info.mobile ) &&        
      this.objCheck( this.KYC.info.nationality ) && 
      this.objCheck( this.KYC.info.last_name ) &&

      this.objCheck( this.facePhoto.uploadKey  ) && 
      this.objCheck( this.idFrontPhoto.uploadKey  ) 

    ){ 
      if(     this.facePhoto.size  > 1000000 || this.idFrontPhoto.size  > 1000000     )  {
        
        this.$store.commit('loading', false ) 
        alert("The file size cannot exceed 1MB.") ; 
        this.facePhoto = null ; 
        this.idFrontPhoto = null ; 

        return   ; 
      }else{ 

          this.KYC.info.facePhoto = (this.facePhoto)? this.facePhoto.uploadKey :null  ;
          this.KYC.info.idFrontPhoto = (this.idFrontPhoto)? this.idFrontPhoto.uploadKey : null ; 
          this.KYC.info.birth  = this.date ; 

          // 업데이트
          if( this.cardHolderId !=null  ) this.KYC.info.cardHolderId = this.cardHolderId ; 

          // //console.log( " true  ::" ,  this.KYC.info)   
          /*************************************************************************************
          //        0|coffee  | 2023-06-28 08:16:43:   code: 200,
          //        0|coffee  | 2023-06-28 08:16:43:   msg: 'Operation Successful',
          //        0|coffee  | 2023-06-28 08:16:43:   data: 10744,
          //        0|coffee  | 2023-06-28 08:16:43:   encrypt: false,
          //        0|coffee  | 2023-06-28 08:16:43:   total: 0,
          //        0|coffee  | 2023-06-28 08:16:43:   serverTime: '2023-06-27 23:16:43'
          ****************************************************************************************/      

          this.$store
                  .dispatch('kyc_req', this.KYC.info )
                  .then((res) => {
                    this.$store.commit('loading', false) ; 
                    
                    alert(res.data.rData.msg) ; 
                    if( res.data.result == true)  {
                      location.reload(); 
                    }

                    // //console.log("res::" ,  res.data) ; 
                    // if ( res.data && res.data.status == true ) {                  
                      

                    //   this.$store.commit('loading', false) ; 
                      
                    // }else if(res.data && res.data.status == false   ){
                  
                    //   this.$store.commit('loading', false) ;  
                    // } else if (res.data && res.data.error) throw res.data.error
                    // else throw res

                  })
                  .catch((err) => {
                    this.$store.commit('loading', false)
                    console.error("err::" , err )
                    // this.$store.dispatch('toast', {
                    //     toast: true,
                    //     toast_msg: this.$t('errorServer'),
                    //     timeout: 3000
                    //   }) ;   
                  }) ; 

      }




        }else { 
          this.$store.commit('loading', false )  ;           
          //console.log( " false ::" ,  this.KYC.info)   

        } 

      //console.log( this.KYC)  ; 
      
    } , 
    submitSwap() {},    
    reset() {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-item .col {
  padding: 0 0.5rem;
}
.select-item {
  width: 100%;
  color: #121212;
}
.swap-icon {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
}
.bottom-btn-left {
  position: fixed;
  width: 50%;
  left: 0;
  bottom: 55px;
}
.bottom-btn-right {
  position: fixed;
  width: 50%;
  left: 50%;
  bottom: 55px;
}
.label-wrapper {
  font-weight: bold;
  font-size: 0.85rem;
  margin-left: 1rem;
}
.max-btn {
  display: flex;
  justify-content: flex-end;
  height: 0;
  transform: translateY(-15px);
}
// .mask-wrapper {
//   background-color: #fff;
//   margin: 0 13px 0 12px;
//   text-align: right;
//   transform: translateY(-56px);
// }
// .placeholder-wrapper {
//   text-align: left;
//   color: #797979;
// }
.bottom-btn-right.theme--light.v-btn.v-btn--disabled,
.bottom-btn-right.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #c8bae8 !important;
  color: #fff !important;
}
.sheet-title {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1.2rem;
}
.sheet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.8rem auto;
}
 
.sheet-title1 {
  font-size: 0.8rem;
  font-weight: bold;
  text-align: left;
  margin-bottom: 1.2rem;
}


.logo-circle {
  background-color: #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.2rem;
}
</style>
